import type { StudentNoteItem } from './orchestrator';
import type { ProjectIdentity } from './project';
import type { StudentClassification } from './studentClassification';

export type EarlyCheckinKind = 'day_8' | 'day_15';
export type EarlyCheckinStatus = 'scheduled' | 'open' | 'waiting_performance' | 'done';
export type EarlyCheckinStage = 'awaiting_fup' | 'fup_8_days' | 'fup_15_days' | 'closed';

export interface EarlyCheckinRow {
  student_id: number;
  student_name: string;
  student_email: string | null;
  joined_at: string | null;
  classification: StudentClassification | null;
  stage: EarlyCheckinStage;
  current_kind: EarlyCheckinKind;
  current_checkin_id: number | null;
  current_status: EarlyCheckinStatus;
  current_due_on: string | null;
  day8_id: number | null;
  day8_due_on: string | null;
  day8_status: EarlyCheckinStatus | null;
  day8_closed_at: string | null;
  day15_id: number | null;
  day15_due_on: string | null;
  day15_status: EarlyCheckinStatus | null;
  day15_closed_at: string | null;
  competence: string | null;
  last_workout_date: string | null;
  project: ProjectIdentity | null;
  is_reactivated: boolean;
  is_sensitive: boolean;
  sensitive_reason: string | null;
  is_pregnant: boolean;
  pregnant_until: string | null;
  is_red_flag: boolean;
  phone_country_code: string | null;
  phone_number: string | null;
  student_notes: StudentNoteItem[];
  notes_summary: string | null;
}

export interface EarlyCheckinFilters {
  search?: string;
  projectCodes?: string[];
  stages?: EarlyCheckinStage[];
  sortOrder?: 'asc' | 'desc';
  joinedAtStart?: string;
  joinedAtEnd?: string;
}

export const EARLY_CHECKIN_ACTIVE_STAGES: readonly EarlyCheckinStage[] = [
  'awaiting_fup',
  'fup_8_days',
  'fup_15_days',
];

export const EARLY_CHECKIN_STAGE_OPTIONS = [
  { value: 'awaiting_fup', label: 'Aguardando FUP' },
  { value: 'fup_8_days', label: 'FUP de 8 dias' },
  { value: 'fup_15_days', label: 'FUP de 15 dias' },
  { value: 'closed', label: 'Encerrada' },
] as const;

export const EARLY_CHECKIN_STAGE_LABELS: Record<EarlyCheckinStage, string> = {
  awaiting_fup: 'Aguardando FUP',
  fup_8_days: 'FUP de 8 dias',
  fup_15_days: 'FUP de 15 dias',
  closed: 'Encerrada',
};

export const EARLY_CHECKIN_STAGE_VARIANTS: Record<
  EarlyCheckinStage,
  'warning' | 'info' | 'primary' | 'success'
> = {
  awaiting_fup: 'warning',
  fup_8_days: 'info',
  fup_15_days: 'primary',
  closed: 'success',
};
